import Modulo13 from "../pages/modulo13/Modulo13";
import Modulo13Conclusion from "../pages/modulo13/Modulo13Conclusion";
import Modulo13U1A1 from "../pages/modulo13/unidad1/Actividad1";
import Modulo13U1A2 from "../pages/modulo13/unidad1/Actividad2";
import Modulo13U1A3 from "../pages/modulo13/unidad1/Actividad3";
import Modulo13U1A4 from "../pages/modulo13/unidad1/Actividad4";
import Modulo13U1A5 from "../pages/modulo13/unidad1/Actividad5";
import Modulo13U1A6 from "../pages/modulo13/unidad1/Actividad6";
import Modulo13U1A7 from "../pages/modulo13/unidad1/Actividad7";
import Modulo13U1A8 from "../pages/modulo13/unidad1/Actividad8";
import Modulo13U1A9 from "../pages/modulo13/unidad1/Actividad9";
import Modulo13U1A10 from "../pages/modulo13/unidad1/Actividad10";
import Modulo13U1A11 from "../pages/modulo13/unidad1/Actividad11";
import Modulo13U1A12 from "../pages/modulo13/unidad1/Actividad12";
import Modulo13U1A13 from "../pages/modulo13/unidad1/Actividad13";
import Modulo13U1A14 from "../pages/modulo13/unidad1/Actividad14";

import Modulo13U2A1 from "../pages/modulo13/unidad2/Actividad1";
import Modulo13U2A2 from "../pages/modulo13/unidad2/Actividad2";
import Modulo13U2A3 from "../pages/modulo13/unidad2/Actividad3";
import Modulo13U2A4 from "../pages/modulo13/unidad2/Actividad4";
import Modulo13U2A5 from "../pages/modulo13/unidad2/Actividad5";
import Modulo13U2A6 from "../pages/modulo13/unidad2/Actividad6";
import Modulo13U2A7 from "../pages/modulo13/unidad2/Actividad7";
import Modulo13U2A8 from "../pages/modulo13/unidad2/Actividad8";
import Modulo13U2A9 from "../pages/modulo13/unidad2/Actividad9";
import Modulo13U2A10 from "../pages/modulo13/unidad2/Actividad10";
import Modulo13U2A11 from "../pages/modulo13/unidad2/Actividad11";
import Modulo13U2A12 from "../pages/modulo13/unidad2/Actividad12";
import Modulo13U2A13 from "../pages/modulo13/unidad2/Actividad13";

import Modulo13U3A1 from "../pages/modulo13/unidad3/Actividad1";
import Modulo13U3A2 from "../pages/modulo13/unidad3/Actividad2";
import Modulo13U3A3 from "../pages/modulo13/unidad3/Actividad3";
import Modulo13U3A4 from "../pages/modulo13/unidad3/Actividad4";
import Modulo13U3A5 from "../pages/modulo13/unidad3/Actividad5";
import Modulo13U3A6 from "../pages/modulo13/unidad3/Actividad6";
import Modulo13U3A7 from "../pages/modulo13/unidad3/Actividad7";
import Modulo13U3A8 from "../pages/modulo13/unidad3/Actividad8";
import Modulo13U3A9 from "../pages/modulo13/unidad3/Actividad9";
import Modulo13U3A10 from "../pages/modulo13/unidad3/Actividad10";
import Modulo13U3A11 from "../pages/modulo13/unidad3/Actividad11";
import Modulo13U3A12 from "../pages/modulo13/unidad3/Actividad12";

export const modulo13 =
    {
      title: "¿Dónde vivimos los peruanos?",
      grade: { name: "Nivel 3", url: "/nivel-3" },
      module: "Módulo 13",
      year: 'Tercer grado',
      tags: [
        { name: "medio ambiente", url: "medio-ambiente" },
        { name: "recursos naturales", url: "recursos-naturales" },
        { name: "manejo de recursos", url: "manejo-de-recursos" },
      ],
      skills: [
        {
          name: "Gestiona responsablemente el espacio y el ambiente",
          url: "/gestiona-responsablemente-el-espacio-y-el-ambiente",
        },
        {
          name: "Gestiona responsablemente los recursos económicos",
          url: "/gestiona-responsablemente-los-recursos-economicos",
        },
      ],
      url: "donde-vivimos-los-peruanos",
      color: "red",
    
      component: <Modulo13 />,
      conclusion: <Modulo13Conclusion />,
      content: [
        {
          name: "Unidad 1: Convivimos",
          path: "unidad-1",
            activities: [
            {
              name: "Actividad 1",
              path: "actividad-1",
              component: <Modulo13U1A1 />,
            },
            {
              name: "Actividad 2",
              path: "actividad-2",
              component: <Modulo13U1A2 />,
            },
            {
              name: "Leemos",
              path: "lectura-1",
              component: <Modulo13U1A3 />,
            },

            {
              name: "Actividad 3",
              path: "actividad-3",
              component: <Modulo13U1A4 />,
            },
            {
              name: "Actividad 4",
              path: "actividad-4",
              component: <Modulo13U1A5 />,
            },
            {
              name: "Actividad 5",
              path: "actividad-5",
              component: <Modulo13U1A6 />,
            },
            {
              name: "Leemos",
              path: "lectura-2",
              component: <Modulo13U1A7 />,
            },

            {
              name: "Actividad 6",
              path: "actividad-6",
              component: <Modulo13U1A8 />,
            },
            {
              name: "Actividad 7",
              path: "actividad-7",
              component: <Modulo13U1A9 />,
            },
            {
              name: "Actividad 8",
              path: "actividad-8",
              component: <Modulo13U1A10 />,
            },
            {
              name: "Leemos",
              path: "lectura-3",
              component: <Modulo13U1A11 />,
            },
            
            {
              name: "Actividad 9",
              path: "actividad-9",
              component: <Modulo13U1A12 />,
            },
            {
              name: "Actividad 10",
              path: "actividad-10",
              component: <Modulo13U1A13 />,
            },
            {
              name: "Leemos",
              path: "lectura-4",
              component: <Modulo13U1A14 />,
            },
          ]
        },
        {
          name: "Unidad 2: Deliberamos",
          path: "unidad-2",
          activities: [
            {
              name: "Actividad 1",
              path: "actividad-1",
              component: <Modulo13U2A1 />,
            },
            {
              name: "Actividad 2",
              path: "actividad-2",
              component: <Modulo13U2A2 />,
            },
            {
              name: "Actividad 3",
              path: "actividad-3",
              component: <Modulo13U2A3 />,
            },
            {
              name: "Leemos",
              path: "lecutra-1",
              component: <Modulo13U2A4 />,
            },

            {
              name: "Actividad 4",
              path: "actividad-4",
              component: <Modulo13U2A5 />,
            },
            {
              name: "Actividad 5",
              path: "actividad-5",
              component: <Modulo13U2A6 />,
            },
            {
              name: "Leemos",
              path: "lectura-2",
              component: <Modulo13U2A7 />,
            },

            {
              name: "Actividad 6",
              path: "actividad-6",
              component: <Modulo13U2A8 />,
            },
            {
              name: "Actividad 7",
              path: "actividad-7",
              component: <Modulo13U2A9 />,
            },
            {
              name: "Leemos",
              path: "lectura-3",
              component: <Modulo13U2A10 />,
            },

            {
              name: "Actividad 8",
              path: "actividad-8",
              component: <Modulo13U2A11 />,
            },
            {
              name: "Actividad 9",
              path: "actividad-9",
              component: <Modulo13U2A12 />,
            },
            {
              name: "Leemos",
              path: "lectura-4",
              component: <Modulo13U2A13 />,
            }
          ]
        },
        {
          name: "Unidad 3: Participamos",
          path: "unidad-3",
          activities: [
            {
              name: "Actividad 1",
              path: "actividad-1",
              component: <Modulo13U3A1 />,
            },
            {
              name: "Leemos",
              path: "lectura-1",
              component: <Modulo13U3A2 />,
            },

            {
              name: "Actividad 2",
              path: "actividad-2",
              component: <Modulo13U3A3 />,
            },
            {
              name: "Actividad 3",
              path: "actividad-3",
              component: <Modulo13U3A4 />,
            },
            {
              name: "Actividad 4",
              path: "actividad-4",
              component: <Modulo13U3A5 />,
            },
            {
              name: "Leemos",
              path: "lectura-2",
              component: <Modulo13U3A6 />,
            },

            {
              name: "Actividad 5",
              path: "actividad-5",
              component: <Modulo13U3A7 />,
            },
            {
              name: "Actividad 6",
              path: "actividad-6",
              component: <Modulo13U3A8 />,
            },
            {
              name: "Leemos",
              path: "lectura-3",
              component: <Modulo13U3A9 />,
            },

            {
              name: "Actividad 7",
              path: "actividad-7",
              component: <Modulo13U3A10 />,
            },
            {
              name: "Actividad 8",
              path: "actividad-8",
              component: <Modulo13U3A11 />,
            },
            {
              name: "Leemos",
              path: "lectura-4",
              component: <Modulo13U3A12 />,
            }
          ]
        }
       
    ]
    };